import { useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Best-effort, fire-and-forget visit tracker. Skips admin routes.
export default function TrackVisits() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;

    let sessionId = sessionStorage.getItem("velora_sid");
    if (!sessionId) {
      sessionId = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      sessionStorage.setItem("velora_sid", sessionId);
    }
    const lang = localStorage.getItem("velora_lang") || "en";

    axios
      .post(`${API}/track`, {
        path: location.pathname + location.search,
        language: lang,
        referrer: document.referrer || null,
        session_id: sessionId,
      })
      .catch((err) => {
        console.warn("visit track failed (non-fatal):", err.message);
      });
  }, [location.pathname, location.search]);

  return null;
}
